/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_TitleInputs */

const en_gyms_title = /** @type {(inputs: Gyms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyms`)
};

const pl_gyms_title = /** @type {(inputs: Gyms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siłownie`)
};

/**
* | output |
* | --- |
* | "Gyms" |
*
* @param {Gyms_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const gyms_title = /** @type {((inputs?: Gyms_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_gyms_title(inputs)
	return en_gyms_title(inputs)
});